import React from "react";

function DraggerIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="8"
      fill="none"
      viewBox="0 0 8 8"
    >
      <circle cx="1" cy="1" r="1" fill="#666"></circle>
      <circle cx="1" cy="4" r="1" fill="#666"></circle>
      <circle cx="1" cy="7" r="1" fill="#666"></circle>
      <circle cx="4" cy="1" r="1" fill="#666"></circle>
      <circle cx="4" cy="4" r="1" fill="#666"></circle>
      <circle cx="4" cy="7" r="1" fill="#666"></circle>
      <circle cx="7" cy="1" r="1" fill="#666"></circle>
      <circle cx="7" cy="4" r="1" fill="#666"></circle>
      <circle cx="7" cy="7" r="1" fill="#666"></circle>
    </svg>
  );
}

export default DraggerIcon;